import React, { useState } from "react";
import { GUIDES, BUSINESS_TYPES } from "../constants";

export function GuidesPage({ t }) {
  const [active, setActive] = useState(null);
  const g = active ? GUIDES.find(x => x.id === active) : null;
  if (g) return (
    <div className="container">
      <button className="btn btn-ghost btn-sm" onClick={() => setActive(null)} style={{ marginBottom:20 }}>← {t("all_guides")}</button>
      <div className="info-card">
        <div style={{ fontSize:40, marginBottom:12 }}>{g.icon}</div>
        <h2 className="page-title" style={{ marginBottom:18 }}>{g.title}</h2>
        <div className="prose-body" dangerouslySetInnerHTML={{ __html:
          g.body.split("\n\n").map(p =>
            p.startsWith("**") && p.endsWith("**")
              ? `<h3>${p.slice(2,-2)}</h3>`
              : `<p>${p.replace(/\*\*(.+?)\*\*/g,"<strong>$1</strong>")}</p>`
          ).join("")
        }} />
      </div>
    </div>
  );
  return (
    <div className="container">
      <div className="page-header">
        <h2 className="page-title">{t("nav_guides")}</h2>
        <p className="page-sub">{t("guides_sub")}</p>
      </div>
      <div className="guides-grid">
        {GUIDES.map(g => (
          <div key={g.id} className="guide-card" onClick={() => setActive(g.id)}>
            <div className="guide-icon">{g.icon}</div>
            <div className="guide-title">{g.title}</div>
            <div className="guide-summary">{g.summary}</div>
            <div className="guide-cta">Read guide →</div>
          </div>
        ))}
      </div>

      <div className="info-card" style={{ marginTop:32, marginBottom:20 }}>
        <div className="section-title">{t("supported_business_types")}</div>
        <div className="home-btype-grid">
          {BUSINESS_TYPES.filter(b => b.id !== "other").map(bt => (
            <div key={bt.id} className="home-btype-card">
              <span className="home-btype-icon">{bt.icon}</span>
              <span className="home-btype-label">{t(bt.label).split(" / ")[0]}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="info-card">
        <div className="section-title">{t("tax_rules")}</div>
        <div className="tax-table">
          <div className="tax-table-head"><span>{t("business")}</span><span>{t("tax_type")}</span><span>{t("authority")}</span><span>{t("rate")}</span></div>
          {BUSINESS_TYPES.filter(b => b.id !== "other").map(bt => (
            <div key={bt.id} className="tax-table-row">
              <span>{bt.icon} {t(bt.label).split(" / ")[0]}</span>
              <span style={{ color:"var(--text-muted)", fontSize:13 }}>{t(bt.taxNote).split(".")[0]}</span>
              <span className="tax-auth-badge">{t(bt.authority).split("(")[0].trim()}</span>
              <span className="tax-rate-badge">{t(bt.rates)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
